var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEditPencil(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "#0000008A",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.7819 1.33301C12.2994 1.33301 11.8169 1.51676 11.4486 1.88509L10.6673 2.66634L13.334 5.33301L14.1153 4.55176C14.8513 3.81576 14.8513 2.62176 14.1153 1.88509C13.747 1.51676 13.2645 1.33301 12.7819 1.33301ZM9.23522 3.99967L2.66732 10.5676C2.66732 10.5676 3.36213 10.571 3.70435 10.9133C4.04658 11.2555 4.03923 11.9395 4.03923 11.9395C4.03923 11.9395 4.74416 11.9531 5.08707 12.296C5.42998 12.6389 5.43275 13.333 5.43275 13.333L12.0007 6.76511L9.23522 3.99967ZM1.77698 11.9997L1.33876 14.3394C1.30337 14.5304 1.46992 14.697 1.6609 14.6616L4.00065 14.2233L1.77698 11.9997Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEditPencil);
export default __webpack_public_path__ + "static/media/Edit Pencil.901d54d403a7c4b05acad884626e8ee2.svg";
export { ForwardRef as ReactComponent };